import { render, staticRenderFns } from "./ModalContributor.vue?vue&type=template&id=960275a6"
import script from "./ModalContributor.vue?vue&type=script&lang=js"
export * from "./ModalContributor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports